<template>
  <div>
    <BatteryEdit></BatteryEdit>
  </div>
</template>

<script>
import BatteryEdit from "@/components/BatteryEdit/index.vue";
export default {
  components: {
    BatteryEdit,
  },
};
</script>

<style></style>
